/**
 * Language types user can select
 */
export enum LanguageType {
    CSharp = 1,
    Python = 2,
    CPP = 3
}